import React from 'react';

import { Details } from 'assets/assetsV1/iconComponents';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const OKRCheckinExitModificationsModal = ({ isOpen, onCancel, onExitConfirmation }) => (
  <ConfirmationModal
    isOpen={isOpen}
    onClose={onCancel}
    isCentered
    title={
      <>
        <Details style={{ marginRight: '4px' }} fill="none" />
        <span>Exit Modifications</span>
      </>
    }
    body={<ModalBody />}
    cancelText="Cancel"
    onCancel={onCancel}
    continueText="Yes"
    onContinue={onExitConfirmation}
  />
);
const ModalBody = () => <TextBodyMedium>Are you sure you want to cancel modifications?</TextBodyMedium>;
